import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { Modal } from '@jove-frontend/uikit';
import HubspotForm from '../HubspotForm';

export interface ModalProps {
  formId?: string;
  title?: string;
  description?: string | React.ReactNode;
}

function HubspotModal({
  showHubspotModal,
  setShowHubspotModal,
  props,
}: {
  showHubspotModal: boolean;
  setShowHubspotModal: Dispatch<SetStateAction<boolean>>;
  props: ModalProps;
}) {
  return (
    <Modal
      isOpen={showHubspotModal}
      onClose={() => setShowHubspotModal(false)}
      variant="plain"
      title=""
      size="lg"
    >
      <div className="px-4">
        {props.title && (
          <h3 className="text-brand-secondary mx-auto max-w-md text-center text-3xl font-extrabold dark:text-gray-400">
            {props.title}
          </h3>
        )}

        {props.description && (
          <p className="mt-4 text-center text-sm">{props.description}</p>
        )}

        <div className="mt-8 flex min-h-[300px] w-full flex-col">
          <HubspotForm formId={props.formId} />
        </div>
      </div>
    </Modal>
  );
}

export function useHubspotModal({ props }: { props?: ModalProps }) {
  const [showHubspotModal, setShowHubspotModal] = useState(false);

  const HubspotModalCallback = useCallback(() => {
    return props ? (
      <HubspotModal
        showHubspotModal={showHubspotModal}
        setShowHubspotModal={setShowHubspotModal}
        props={props}
      />
    ) : null;
  }, [showHubspotModal, setShowHubspotModal]);

  return useMemo(
    () => ({
      setShowHubspotModal,
      HubspotModal: HubspotModalCallback,
    }),
    [setShowHubspotModal, HubspotModalCallback]
  );
}
